import { render, staticRenderFns } from "./GroupTransactionRecordInfo.vue?vue&type=template&id=0514d202"
import script from "./GroupTransactionRecordInfo.vue?vue&type=script&lang=js"
export * from "./GroupTransactionRecordInfo.vue?vue&type=script&lang=js"
import style0 from "./GroupTransactionRecordInfo.vue?vue&type=style&index=0&id=0514d202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports